<!--
 * @Description: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-09-14 17:31:40
 * @LastEditTime: 2020-09-14 21:03:16
-->
<template>
  <div class="nr-count-down-container">
    <span class="date">{{h}}</span>
    <span class="colon">:</span>
    <span class="date">{{m}}</span>
    <span class="colon">:</span>
    <span class="date">{{s}}</span>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'nr-count-down',
  data() {
    return {
      d: '00',
      h: '00',
      m: '00',
      s: '00',
    }
  },
  props: {
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    }
  },
  created() {
    this.countTime()
  },
  methods: {
    countTime: function() {
      //获取当前时间
      var date = new Date()
      var now = date.getTime()
      //设置截止时间
      var endDate = new Date(moment(this.end).format('YYYY/MM/DD HH:mm:ss'))
      var end = endDate.getTime()
      //时间差
      var leftTime = end - now
      
      
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24); //天数没用到，暂且写上
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24),
          m = Math.floor((leftTime / 1000 / 60) % 60),
          s = Math.floor((leftTime / 1000) % 60);

        
        this.h = h < 10 ? `0${h}` : h;
        this.m = m < 10 ? `0${m}` : m;
        this.s = s < 10 ? `0${s}` : s;
        
        //递归每秒调用countTime方法，显示动态时间效果
        this.timer = setTimeout(this.countTime, 1000)
      }else{
        clearTimeout(this.timer)
        this.$emit('onEnd')
      }
    },
  },
  destroyed() {
    if(this.timer) clearTimeout(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.nr-count-down-container{
  display: flex;
  align-items: center;
}
</style>